import "../../css/components/Social.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import g from "../../js/utils/globals";
import at from "../../js/utils/at";
import Logger from "../utils/Logger";

const logger = new Logger(__filename);

const zara = window.zara || { appConfig: null, mkt: { require: null } };
const socialPopUp = {
  facebook: "width=640,height=400",
  twitter: "width=500,height=400",
  pinterest: "width=640,height=400",
  sinaweibo: "width=500,height=400",
  vk: "width=500,height=400",
};

class Widget extends Component {
  constructor(props) {
    super(props);
    this.className = `mktFont-${this.props.social} _sharingMethod fonticon`;
    if (props.styles && props.styles.color === "#FFFFFF") {
      this.className += " gray-on-hover";
    }
  }

  componentDidMount = () => {
    window.addEventListener("click", this.stopPropagationBubble, true);
  };

  componentWillUnmount = () => {
    window.removeEventListener("click", this.stopPropagationBubble, true);
  };

  // makes no sense
  // eslint-disable-next-line react/sort-comp
  stopPropagationBubble = e => {
    if (e.target === this.el) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.processShare();
    }
  };

  shortenUrl = url => {
    url = url.replace(/\/\w{2}\/(\w{2}\/)?/, "/share/v2/");
    url = at("CN") ? url.replace(".com", ".cn") : url.replace(".cn", ".com");
    return url;
  };

  sendAnaliticsTracking = type => {
    window.ga("close.send", "social", {
      socialNetwork: type,
      socialAction: "Share",
      socialTarget: location.hostname,
      dimension11: `ZARA_${zara.mkt.countryCode}`,
      dimension12: zara.mkt.langCode,
      page: `/static/zara_close/sale/zaras/index.html?.com/${g.langCode}&_pn=/im/web/ZARA_${g.countryCode}/Pagina_Cierre`,
      title: "ZARA - Web Oficial",
      hostname: location.hostname,
      hitType: "pageview",
      dimension1: "web-pc",
      dimension2: "12.2.0",
      dimension3: "1402940558484",
      dimension4: "1.6.4",
      dimension8: navigator.platform,
    });

    window.ga("close.send", "event", {
      eventAction: `Share_${type}`,
      eventCategory: "Pagina_Cierre",
      socialTarget: location.hostname,
      dimension11: `ZARA_${zara.mkt.countryCode}`,
      dimension12: zara.mkt.langCode,
      page: `/static/zara_close/sale/zaras/index.html?.com/${g.langCode}&_pn=/im/web/ZARA_${g.countryCode}/Pagina_Cierre`,
      title: "ZARA - Web Oficial",
      hostname: location.hostname,
      hitType: "pageview",
      dimension1: "web-pc",
      dimension2: "12.2.0",
      dimension3: "1402940558484",
      dimension4: "1.6.4",
      dimension8: navigator.platform,
    });
  };

  param = (url, params = {}) => {
    const parameters = Object.keys(params)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join("&");
    return `${url}?${parameters}`;
  };

  getDescription = description => {
    if (!description) {
      const tokens = window.document.title.split("-");
      tokens.pop();
      let hash = this.props.hashtag || "#zaraeditorial";
      if (at("CN")) {
        hash += "#";
      }
      if (this.props.hashtag) {
        if (at("CN")) {
          hash += "#";
        }
      }
      description = `${hash} - ${tokens.reverse().join(" - ")}`.clean();
    }
    return description;
  };

  generateShareUrl = () => {
    let description = this.getDescription(this.props.description);

    description = `ZARA - ${description}`;
    let url = this.shortenUrl(this.props.url);
    const media = this.props.media;
    switch (this.props.social) {
      case "facebook":
        url += `?shareImageUrl=${encodeURIComponent(media)}`;
        return `http://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
      case "twitter":
        return this.param("http://twitter.com/share", {
          url,
          text: `@${description}`,
        });
      case "vk":
        return `http://vkontakte.ru/share.php?url=${url}`;
      case "pinterest":
        return this.param("http://pinterest.com/pin/create/button/", {
          url,
          media,
          is_video: false,
          description,
        });
      case "sinaweibo":
        return this.param("http://v.t.sina.com.cn/share/share.php", {
          url,
          title: description,
        });
      default:
        logger.error(`Red desconocida: ${this.props.social} (sólo sé construir 'facebook', 'twitter' y 'pinterest')`);
    }
  };
  mergeQueryString = (url, params) => {
    const tokens = url.split("?");
    const base = tokens[0];
    const paramsObj = {};
    if (tokens.length > 1) {
      const parameters = tokens[1];
      parameters.split("&").forEach(param => {
        const paramSplitted = param.split("=");
        return (paramsObj[paramSplitted[0]] = decodeURIComponent(paramSplitted[1]));
      });
      params = Object.assign(params, paramsObj);
    }
    return this.param(base, params);
  };

  processShare = () => {
    const type = this.props.social;
    let itxGoParameters;
    if (this.props.analytics) this.sendAnaliticsTracking(type);
    let media = this.props.media;
    if (!Array.from(this.props.media).includes("?")) {
      media += `?${g.lastStaticSyncTimestamp}`;
    }
    let linkUrl = this.generateShareUrl(type);
    if (["facebook", "vk", "sinaweibo"].indexOf(type) > -1) {
      itxGoParameters = {
        title: this.getDescription(this.props.description),
        description: this.getDescription(this.props.description || this.props.detailDescription),
      };
      if (media) {
        // The image we send to itxGo is relative to 'photos'
        // if we send a different uri itxGo will ignore it
        itxGoParameters.image = `../${media
          .split("/")
          .splice(3, media.length - 3)
          .join("/")}`;
      }
      linkUrl = this.mergeQueryString(linkUrl, itxGoParameters);
    }
    window.open(linkUrl, "Share", socialPopUp[type]);
  };
  render = () => (
    <i
      className={this.className}
      datatype={this.props.social}
      aria-haspopup
      onClick={this.processShare}
      ref={el => {
        this.el = el;
      }}
    />
  );
}

Widget.propTypes = {
  url: PropTypes.string.isRequired,
  description: PropTypes.string,
  hashtag: PropTypes.string,
  media: PropTypes.string.isRequired,
  social: PropTypes.string.isRequired,
  styles: PropTypes.object,
  analytics: PropTypes.bool,
};

export default Widget;
